import React, { useState, useCallback } from "react";
import "./profile.scss";
import Form, { Item } from "devextreme-react/form";
import Switch from "devextreme-react/switch";
import { useAuth } from "../../contexts/auth";
import notify from "devextreme/ui/notify";
import {
  EmailRule,
  RequiredRule,
  CompareRule,
  Label,
} from "devextreme-react/form";

const { REACT_APP_SERVER_URL } = process.env;
export default () => {
  const { user, signOut } = useAuth();
  const [notes, setNotes] = useState(
    "Sandra is a CPA and has been our controller since 2008. She loves to interact with staff so if you`ve not met her, be certain to say hi.\r\n\r\nSandra has 2 daughters both of whom are accomplished gymnasts."
  );
  //const employee =JSON.parse(localStorage.getItem('user'));
  const employee = user.user;

  // The form offers to save a draft on entry unless the user silenced it there.
  // The key stores "muted", the switch shows "shown", hence the inverted read and
  // the removeItem on enable — absent means default, matching form_autosave.
  const [showDraftPrompt, setShowDraftPrompt] = useState(() => {
    try { return localStorage.getItem("form_autosave_prompt") !== "off"; }
    catch (e) { return true; }
  });

  const onDraftPromptChanged = useCallback((e) => {
    setShowDraftPrompt(e.value);
    try {
      if (e.value) localStorage.removeItem("form_autosave_prompt");
      else localStorage.setItem("form_autosave_prompt", "off");
    } catch (err) { /* private browsing: the switch still reflects this session */ }
  }, []);
  const formData = {};
  let password = "";
  const passwordOpt = {
    mode: "password",
  };
  const passOptions = {
    mode: "password",
    onValueChanged: (e) => {
      password = formData.Password;
    },
  };
  const buttonOptions = {
    text: "החלף",
    type: "success",
    useSubmitBehavior: true,
    onClick: function (e) {
      const res = e.validationGroup.validate();
      if (res.status === "valid") {
        sendPwToDB(formData);
      } else {
        const msg = "אופס... יש כמה שדות חסרים";
        notify(msg, "error", 3000);
      }
    },
  };

  return (
    <React.Fragment>
      <h2 className={"content-block"}>פרופיל משווק</h2>
      <div className={"content-block dx-card responsive-paddings"}>
        <Form
          id={"form"}
          defaultFormData={employee}
          readOnly={true}
          onFieldDataChanged={(e) =>
            e.dataField === "Notes" && setNotes(e.value)
          }
          labelLocation={"top"}
          colCountByScreen={colCountByScreen}
        />
      </div>
      <h2 className={"content-block"}>העדפות</h2>
      <div className={"content-block dx-card responsive-paddings"}>
        <div className="pref-row">
          <div className="pref-text">
            <div className="pref-label">
              הצגת הצעה לשמור טיוטה
              <span className="pref-badge">מומלץ</span>
            </div>
            <div className="pref-hint">
              בכניסה לטופס חדש נציג הצעה לשמור טיוטה ולהפעיל שמירה אוטומטית.
              כך הנתונים שמילאת נשמרים ברקע ולא ילכו לאיבוד אם הדפדפן ייסגר או
              שתצטרך להמשיך מאוחר יותר.
            </div>
          </div>
          <Switch value={showDraftPrompt} onValueChanged={onDraftPromptChanged} />
        </div>
      </div>
      <h2 className={"content-block"}>החלף סיסמא</h2>
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={handleSubmit}>
          <Form
            labelLocation={"top"}
            colCountByScreen={1}
            formData={formData}
            showValidationSummary={true}
          >
            <Item dataField="email" editorType="dxTextBox" isRequired={true}>
              <RequiredRule message="Email is required" />
              <EmailRule message="Email is invalid" />
            </Item>
            <Item
              dataField="oldPassword"
              editorType="dxTextBox"
              isRequired={true}
              editorOptions={passwordOpt}
            >
              <Label text="Old Password" />
            </Item>
            <Item
              dataField="Password"
              editorType="dxTextBox"
              name="password"
              editorOptions={passOptions}
            >
              <RequiredRule message="Password is required" />
            </Item>
            <Item
              editorType="dxTextBox"
              dataField="confirmPassword"
              editorOptions={passwordOpt}
            >
              <Label text="Confirm Password" />
              <RequiredRule message="Confirm Password is required" />
              <CompareRule
                message="Password and Confirm Password do not match"
                comparisonTarget={function name() {
                  return password;
                }}
              />
            </Item>

            <Item itemType="button" buttonOptions={buttonOptions} />
          </Form>
        </form>
      </div>
    </React.Fragment>
  );
};

async function sendPwToDB(formData) {
  const data = {
    Email: formData.email,
    Password: formData.Password,
    OldPassword: formData.oldPassword,
  };
  const response = await fetch(`${REACT_APP_SERVER_URL}ChangePassword`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (response.ok) {
    const msg = "הסיסמא הוחלפה בהצלחה";
    notify(msg, "success", 3000);
  } else {
    const msg = "יש טעות במייל או בסיסמא";
    notify(msg, "error", 3000);
  }
}

const handleSubmit = (e) => {
  e.preventDefault();
};
const colCountByScreen = {
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
};
